import { Instagram, Youtube, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/data";
import { useContent } from "../context/ContentContext";

export const Footer = () => {
  const { content } = useContent();
  const c = content?.contact || {};
  const email = c.email || "info@strassenwert.de";
  const phone = c.phone || "+49 175 50 03 19 2";
  const phoneLink = c.phone_link || "+491755003192";
  const handles = content?.studios?.handles || [];
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#030303] border-t border-white/[0.06] pt-20 pb-10 grain"
    >
      <div className="absolute top-0 left-0 right-0 h-px hairline-red opacity-50" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-6">
        <div className="md:col-span-5">
          <Link
            to="/"
            className="inline-flex items-center gap-3 group"
            data-testid="footer-logo"
          >
            <img
              src={LOGO_URL}
              alt="STRAßENWERT"
              className="h-14 md:h-16 w-auto drop-shadow-[0_0_16px_rgba(255,0,51,0.35)] group-hover:drop-shadow-[0_0_24px_rgba(255,0,51,0.6)] transition-all duration-500"
            />
          </Link>
          <p className="mt-8 text-sm text-zinc-500 max-w-md leading-relaxed">
            Independent Music Label · Premium Operator im deutschen Rap.
            Management · Promotion · Strategie · Content.
          </p>

          <div className="mt-10 space-y-3">
            <a
              href={`mailto:${email}`}
              className="flex items-center gap-3 text-sm text-zinc-400 hover:text-white transition-colors"
              data-testid="footer-email"
            >
              <Mail size={14} className="text-[#ff0033]" />
              {email}
            </a>
            <a
              href={`tel:${phoneLink}`}
              className="flex items-center gap-3 text-sm text-zinc-400 hover:text-white transition-colors"
              data-testid="footer-phone"
            >
              <Phone size={14} className="text-[#ff0033]" />
              {phone}
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-600 font-semibold mb-5">
            Standort
          </div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>Berlin · HQ</li>
            <li>Studios im Aufbau</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-600 font-semibold mb-5">
            Legal
          </div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>
              <Link
                to="/impressum"
                className="hover:text-white transition-colors"
                data-testid="footer-link-impressum"
              >
                Impressum
              </Link>
            </li>
            <li>
              <Link
                to="/datenschutz"
                className="hover:text-white transition-colors"
                data-testid="footer-link-datenschutz"
              >
                Datenschutz
              </Link>
            </li>
            <li>
              <Link
                to="/agb"
                className="hover:text-white transition-colors"
                data-testid="footer-link-agb"
              >
                AGB
              </Link>
            </li>
            <li>
              <Link
                to="/geschichte"
                className="hover:text-[#ff0033] transition-colors text-zinc-500"
                data-testid="footer-link-geschichte"
              >
                Unsere Geschichte
              </Link>
            </li>
            <li>
              <Link
                to="/admin"
                className="hover:text-[#ff0033] transition-colors text-zinc-500"
                data-testid="footer-link-admin"
              >
                Admin
              </Link>
            </li>
            <li>
              <Link
                to="/drive"
                className="hover:text-[#ff0033] transition-colors text-zinc-500"
                data-testid="footer-link-drive"
              >
                Drive
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-600 font-semibold mb-5">
            Social
          </div>
          <div className="flex items-center gap-4 text-zinc-400">
            {handles[0] && (
              <a
                href={handles[0].url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={handles[0].tag}
              >
                <Instagram
                  size={18}
                  className="hover:text-[#ff0033] cursor-pointer transition-colors"
                />
              </a>
            )}
            {handles[1] && (
              <a
                href={handles[1].url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={handles[1].tag}
              >
                <Instagram
                  size={18}
                  className="hover:text-[#ff0033] cursor-pointer transition-colors"
                />
              </a>
            )}
            <Youtube
              size={18}
              className="hover:text-[#ff0033] cursor-pointer transition-colors"
            />
          </div>
          <div className="mt-4 text-[10px] tracking-[0.2em] uppercase text-zinc-600 space-y-1">
            {handles.map((h) => (
              <div key={h.tag}>{h.tag}</div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-16 border-t border-white/[0.05] pt-6">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-wrap items-center justify-between gap-4 text-[10px] tracking-[0.3em] uppercase text-zinc-600">
          <span>© {year} STRAßENWERT — Alle Rechte vorbehalten.</span>
          <span>Made in Germany · Built for the Streets</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
